const languageSettingsName = Object.freeze({
  gem: 'ruby',
  git: 'git',
  go: 'git',
  mvn: 'java',
  npm: 'npm',
  nuget: 'dotnet',
  pip: 'python',
  pod: 'cocoa',
});

/**
 * Returns if a settings page for a fetcher exists
 * @param {string} fetcher  get fetcher settings url
 * @returns {boolean} if settings page exists
 */
export const hasLanguageSettingsPage = (fetcher: string) => languageSettingsName.hasOwnProperty(fetcher);

/**
 * Get the URL for fetcher/language settings page
 * @param {string} fetcher  get fetcher settings url
 * @returns {string} fetcher settings url or null of none exists
 */
export const getFetcherSettingsUrl = (fetcher: string | null) => {
  if (!fetcher) {
    return null;
  }

  const language = languageSettingsName[fetcher as keyof typeof languageSettingsName];

  if (!language) {
    return null;
  }

  return `/account/settings/languages/${language}`;
};
